import { ROUTER_API } from 'app/constants/api.constant';
import BaseApi from 'app/services/api/base.api';
import {
  SelectedStoreDTO,
  WebPushSubscriptionInDTO,
  WebPushSubscriptionInfoInDTO,
  WebPushSubscriptionOutDTO,
} from '../type';

export const webPushSubscriptionApi = new BaseApi({ baseURL: ROUTER_API, tokenKey: 'token', timeout: 20000 });

export const getPublicVapidKeyApi = async (): Promise<string> => {
  const response = await webPushSubscriptionApi.api.get<{ publicKey: string }>(
    `/services/v2/notifications/web/vapid-public-key`,
  );
  return response.data.publicKey;
};

export const createWebPushSubscriptionApi = async (subscription: WebPushSubscriptionOutDTO) => {
  const response = await webPushSubscriptionApi.api.post<WebPushSubscriptionInDTO>(
    `/api/v2/notifications/web/subscriptions`,
    subscription,
  );
  return response.data;
};

export const searchWebPushSubscriptionApi = async (userId: string, deviceId: string) => {
  const response = await webPushSubscriptionApi.api.get<WebPushSubscriptionInDTO>(
    `/api/v2/notifications/web/subscriptions/search`,
    {
      params: {
        userId,
        deviceId,
      },
    },
  );
  return response.data;
};

export const deleteWebPushSubscriptionApi = async (subscriptionId: string) => {
  await webPushSubscriptionApi.api.delete(`/api/v2/notifications/web/subscriptions/${subscriptionId}`);
};

export const updateWebPushSubscriptionSelectedStoresApi = async (
  subscriptionId: string,
  selectedStores: SelectedStoreDTO[],
) => {
  const response = await webPushSubscriptionApi.api.patch<WebPushSubscriptionInDTO>(
    `/api/v2/notifications/web/subscriptions/${subscriptionId}/scopes`,
    selectedStores,
  );
  return response.data;
};

export const updateWebPushSubscriptionInfoApi = async (subscriptionId: string, info: WebPushSubscriptionInfoInDTO) => {
  const response = await webPushSubscriptionApi.api.patch<WebPushSubscriptionInDTO>(
    `/api/v2/notifications/web/subscriptions/${subscriptionId}/auth`,
    info,
  );
  return response.data;
};
